import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'td-wb-page-panel',
  template: '<ng-content />',
  styleUrls: ['page-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagePanelComponent {
  /* eslint-disable lines-between-class-members */
  @Input()
  set touchEdge(value: boolean) {
    this._touchEdge = value;
  }
  @HostBinding('class.td-wb-page-panel--touch-edge')
  get touchEdgePadding(): boolean {
    return this._touchEdge;
  }

  @Input()
  set touchEdgeReverse(value: boolean) {
    this._touchEdgeReverse = value;
  }
  @HostBinding('class.td-wb-page-panel--touch-edge-reverse')
  get touchEdgeReversePadding(): boolean {
    return this._touchEdgeReverse;
  }

  @Input()
  set top(value: boolean) {
    this._top = value;
  }
  @HostBinding('class.td-wb-page-panel--top')
  get topPadding(): boolean {
    return this._top;
  }

  @Input()
  set bottom(value: boolean) {
    this._bottom = value;
  }
  @HostBinding('class.td-wb-page-panel--bottom')
  get bottomPadding(): boolean {
    return this._bottom;
  }

  @Input()
  set left(value: boolean) {
    this._left = value;
  }
  @HostBinding('class.td-wb-page-panel--left')
  get leftPadding(): boolean {
    return this._left;
  }

  @Input()
  set right(value: boolean) {
    this._right = value;
  }
  @HostBinding('class.td-wb-page-panel--right')
  get rightPadding(): boolean {
    return this._right;
  }
  /* eslint-enable lines-between-class-members */

  private _top: boolean = false;
  private _bottom: boolean = false;
  private _left: boolean = true;
  private _right: boolean = true;
  private _touchEdge: boolean = false;
  private _touchEdgeReverse: boolean = false;
}
